import { render } from "./ProfileAboutMe.vue?vue&type=template&id=226a822f&scoped=true&ts=true"
import script from "./ProfileAboutMe.vue?vue&type=script&lang=ts"
export * from "./ProfileAboutMe.vue?vue&type=script&lang=ts"

import "./ProfileAboutMe.vue?vue&type=style&index=0&id=226a822f&lang=stylus"
import "./ProfileAboutMe.vue?vue&type=style&index=1&id=226a822f&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226a822f"]])

export default __exports__